/**
 * LoadingSpinner - Loading indicator
 * @param {Object} props
 * @param {string} [props.size='md'] - Size variant ('sm' | 'md' | 'lg')
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.dataTestId] - Optional data-testid
 */
export function LoadingSpinner({ size = 'md', className = '', dataTestId }) {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4',
  };

  return (
    <div className={`flex items-center justify-center ${className}`} data-testid={dataTestId}>
      <div
        className={`${sizeClasses[size]} border-line border-t-brand rounded-full animate-spin`}
        data-testid={dataTestId ? `${dataTestId}-indicator` : undefined}
      />
    </div>
  );
}

/**
 * FullPageLoader - Full page loading overlay
 * @param {Object} props
 * @param {string} [props.dataTestId] - Optional data-testid
 */
export function FullPageLoader({ dataTestId = 'full-page-loader' }) {
  return (
    <div className="fixed inset-0 bg-background/80 flex items-center justify-center z-50" data-testid={dataTestId}>
      <LoadingSpinner size="lg" dataTestId={`${dataTestId}-spinner`} />
    </div>
  );
}
